import React, { useEffect, useState } from 'react';
import { fetchJson } from '@altibox/lib/dist/api';
import * as Cookies from 'js-cookie';
import styles from './app.module.scss';

export interface RedirectHgwToUrlConfig {
  [key: string]: string;
}

interface HgwApiResponse {
  data: { [k: number]: Hgw };
  message: string;
  messageCode: string | null;
  status: 'success' | 'failure';
}
interface Location {
  siteId: number;
}
interface Hgw {
  deviceType: string;
}

async function getSiteId() {
  const selectedLocation = Cookies.get('locationPicker_SelectedLocation');
  const locations = await fetchJson<{ value?: Location[] }>('/api/customer/servicelocations').then((res) => res.value);
  if (selectedLocation) {
    const location = locations?.find((location) => location.siteId === Number.parseInt(selectedLocation));
    if (location) {
      return location.siteId;
    }
  }

  if (locations?.length === 1) {
    return locations[0].siteId;
  }

  throw Error(
    'Gateway type redirect is allowed for customers with 1 location only. Locations found: ' +
      (locations ? locations.length : 0),
  );
}

async function getGatewayType(siteId: number) {
  const hgwRes = await fetchJson<HgwApiResponse>(`/api/wifi/getwifibylocation?siteid=${siteId}`);
  if (hgwRes.status === 'success') {
    const hgw = hgwRes.data[+siteId];
    return hgw.deviceType;
  }

  throw Error('/api/wifi/getwifibylocation failed with messageCode ' + hgwRes.messageCode);
}

interface Props {
  config: RedirectHgwToUrlConfig;
}
export const App = (props: Props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    if (!props.config || Object.keys(props.config).length < 1) {
      throw Error('gatewayRedirect init-config not found');
    }

    window.altibox.auth.isLoggedIn((loggedIn: boolean) => {
      setIsLoggedIn(loggedIn);
      if (!loggedIn) {
        return;
      }

      getSiteId()
        .then((siteId) => getGatewayType(siteId))
        .then((gatewayType) => {
          if (!gatewayType) {
            throw Error('Gateway type could not be identified.');
          }

          const redirectUrl = props.config[gatewayType];
          if (!redirectUrl) {
            console.warn('No redirect config found for gateway type ' + gatewayType);
          }

          window.location.replace(redirectUrl); // replacing current page to avoid back-button-loop
        })
        .catch((error) => {
          console.warn('Could not redirect based on gateway type: ' + error);
        });
    });
  }, [props.config]);

  return (
    <div className={styles.app}>
      {!isLoggedIn && (
        <>
          <button
            id='wp-gateway-type-redirect-login'
            className={styles.loginButton}
            onClick={window.altibox.auth.ssoLogin}
            aria-label='Logg inn på Mine sider'
          >
            Logg inn
          </button>
          <p aria-hidden={true}>... på Mine Sider</p>
        </>
      )}
    </div>
  );
};
